//@ts-nocheck
//@ts-ignore
/* eslint-disable */
// Side-effect import: clears the stale onboarding store on a fresh tab session.
// Must stay FIRST — it has to run before the zustand store hydrates from
// localStorage (which happens at import time of the store module).
import './onboarding/helpers/clearStaleStorage';
// Side-effect import: captures the FB ad labels from the URL and registers the
// axios interceptor that attaches them to `POST /v2/user` and every
// `PUT /user/update-by-token/:id`. Must stay right after the storage wipe above
// — the wipe preserves the labels, and this captures fresh ones before the
// first render can fire a request.
import './onboarding/helpers/adAttribution';
import React, { StrictMode, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import configureStore from './store';
import Analytics from '@web-solutions/module-analytics';
import Attribution from '@web-solutions/module-attribution';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { initLocalization } from './localization';
import { getMagnusToken } from 'src/store/app/utils';
import packageInfo from '../package.json';
import { APP_LINKS } from 'src/constants/general';
import App from './onboarding/App';
import { readFunnelFlow, storeFunnelSearch } from './onboarding/helpers/checkoutApi';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { LocalizationInitializer } from './localization/LocalizationInitializer';

// StrictMode renders Root twice; the attribution health event must fire once.
let attributionDiagSent = false;

const Root = () => {
  const { store, persistor } = configureStore();
  Analytics.init(getMagnusToken(), packageInfo.version);
  Attribution.init(APP_LINKS);

  // Once per page load: did the ad labels survive storage, and where were they
  // read from. Half the paying sessions reached the backend with no attribution
  // and nothing in the existing events could say why — this makes it a query.
  if (!attributionDiagSent) {
    attributionDiagSent = true;
    Analytics.trackEvent('attribution', 'state', Attribution.getAdAttributionDiag());
  }
  // const { activeLanguages } = useRemoteConfig();

  const p = new URLSearchParams(window.location.search);

  // `flow` selects the quiz flow / remote-config segment. On a Stripe hosted
  // Checkout return the URL only carries `?session_id` (the `flow` param is
  // dropped), so fall back to the value persisted before the redirect. When the
  // URL does carry `flow`, refresh the persisted copy so it never goes stale.
  const urlFlow = p.get('flow');
  if (urlFlow) {
    storeFunnelSearch();
  }
  const flow = urlFlow || readFunnelFlow();
  if (flow) {
    Analytics.setUserProperty('flow', flow);
  }

  // useEffect(() => {
  //   if (activeLanguages && activeLanguages.length > 0) {
  //     initLocalization(activeLanguages);
  //   }
  // }, [activeLanguages]);

  return (
    <StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LocalizationInitializer />
          <App />
        </PersistGate>
      </Provider>
    </StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
